import { axios } from '$app-web/api/axios';
import { extractAccessToken } from '$app-web/api/axios/interceptors/authorization';
import { transformToCamelCase, transformToSnakeCase } from '$app-web/utils';

import { Endpoints } from '../constant';
import type { AgentEvent, SqlAgentChatRequest } from './types';

function buildUrl(): string {
    const baseUrl = (axios.defaults.baseURL ?? '').replace(/\/$/, '');
    return `${baseUrl}${Endpoints.SqlAgent.Chat}`;
}

export async function* streamSqlAgentChat(request: SqlAgentChatRequest): AsyncGenerator<AgentEvent, void, void> {
    const token = extractAccessToken();
    const response = await fetch(buildUrl(), {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            ...(token !== '' ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: JSON.stringify(transformToSnakeCase(request)),
    });

    if (!response.ok) throw new Error(`Request failed with status ${response.status}`);
    if (!response.body) throw new Error('Response has no body');

    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buffer = '';

    // eslint-disable-next-line no-constant-condition
    while (true) {
        // eslint-disable-next-line no-await-in-loop
        const { done, value } = await reader.read();
        if (done) break;

        buffer += decoder.decode(value, { stream: true });
        const parts = buffer.split('\n\n');
        buffer = parts.pop() ?? '';

        for (const line of parts) {
            if (!line.startsWith('data: ')) continue;
            try {
                yield transformToCamelCase(JSON.parse(line.slice(6))) as AgentEvent;
            } catch (parseError) {
                // eslint-disable-next-line no-console
                console.error('Failed to parse SSE frame from AI assistant', { line, parseError });
            }
        }
    }
}
